export default __webpack_public_path__ + "a07949a6506ef4fb7ca97af67dc21e1d.svg";